import { useQuery } from '@tanstack/vue-query'
import type { Ref } from 'vue'
import { computed } from 'vue'

import { getReminder, REMINDER_QUERY_KEY } from '@/features/admin/reminders/api'
import type { GetCycleResponseType } from '@/features/admin/reminders/types'

function V1ToV2DataMiddleware({ data }: { data: GetCycleResponseType | undefined }) {
  const cycle = data
  if (cycle) {
    return {
      id: cycle.id,
      name: cycle.name,
      startDate: cycle.startDate,
      endDate: cycle.endDate,
      programIds: cycle.programIds,
      createdAt: cycle.createdAt,
      updatedAt: cycle.updatedAt,
      reminders: cycle.reminders,
      program: cycle.programs,
    }
  }

  return cycle || {}
}

const useReminder = (reminderIdRef: Ref<string | null>) => {
  // Vérifier si toutes les données nécessaires sont présentes pour effectuer la requête
  const isReminderQueryEnabledRef = computed(() => !!reminderIdRef.value)

  const reminderQuery = useQuery({
    queryKey: [
      REMINDER_QUERY_KEY,
      {
        id: reminderIdRef.value,
      },
    ],
    queryFn: () =>
      getReminder({
        id: reminderIdRef.value!,
      }),
    enabled: isReminderQueryEnabledRef,
  })

  const data = computed(() => {
    return V1ToV2DataMiddleware({
      data: reminderQuery.data.value,
    })
  })

  return {
    reminderRef: data,
    isPendingRef: reminderQuery.isPending,
  }
}

export default useReminder
